import React from "react";
import { useTranslation } from "react-i18next";
import AppHeader from "../common/AppHeader";
import styles from "../css/LegalPage.module.css";

const termsContent = {
  en: {
    title: "Terms & Conditions",
    updated: "Last updated: March 31, 2026",
    intro:
      "These Terms & Conditions govern the use of Bhada24 by service providers. The platform is intended to help service providers list services and grow their business through genuine customer connections.",
    sections: [
      {
        heading: "1. Platform Use",
        points: [
          "Service providers may use the platform to create profiles, list services, receive enquiries, and connect with customers for lawful business purposes.",
          "Providers must not use the platform for misleading listings, false claims, spam, abusive conduct, or unlawful activity.",
        ],
      },
      {
        heading: "2. Service Listings",
        points: [
          "Providers are responsible for the accuracy of their service descriptions, pricing, availability, contact details, and related business information.",
          "Bhada24 may remove, limit, or update listings that appear incorrect, harmful, misleading, or in violation of platform rules.",
        ],
      },
      {
        heading: "3. Business Contact Sharing",
        points: [
          "By using the platform, service providers agree that their business contact details may be shared with users for business purposes only.",
          "This includes enabling customers to contact providers regarding listed services, enquiries, bookings, quotations, or service discussions.",
        ],
      },
      {
        heading: "4. Provider Responsibilities",
        points: [
          "Providers are responsible for all information submitted through their account and for all communication or commitments made to customers through or after platform interaction.",
          "Providers must maintain professionalism and comply with applicable laws and business obligations.",
        ],
      },
      {
        heading: "5. No Business Guarantee",
        points: [
          "Bhada24 provides a platform for visibility and connection, but does not guarantee leads, bookings, customer conversion, or business growth.",
          "Any business relationship or transaction between a provider and a customer is their own responsibility.",
        ],
      },
      {
        heading: "6. Account Suspension or Removal",
        points: [
          "We may suspend, restrict, or remove accounts that violate platform policies, misuse user data, or use the platform in a harmful or unauthorized way.",
        ],
      },
    ],
  },
  hi: {
    title: "नियम एवं शर्तें",
    updated: "अंतिम अपडेट: 31 मार्च 2026",
    intro:
      "ये नियम एवं शर्तें Bhada24 प्लेटफॉर्म के उपयोग को नियंत्रित करती हैं। यह प्लेटफॉर्म सेवा प्रदाताओं को अपनी सेवाएं सूचीबद्ध करने और वास्तविक ग्राहकों से जुड़कर व्यवसाय बढ़ाने में मदद करने के लिए बनाया गया है।",
    sections: [
      {
        heading: "1. प्लेटफॉर्म का उपयोग",
        points: [
          "सेवा प्रदाता इस प्लेटफॉर्म का उपयोग प्रोफाइल बनाने, सेवाएं सूचीबद्ध करने, पूछताछ प्राप्त करने और वैध व्यवसायिक उद्देश्य के लिए ग्राहकों से जुड़ने हेतु कर सकते हैं।",
          "प्लेटफॉर्म का उपयोग भ्रामक लिस्टिंग, गलत दावे, स्पैम, दुर्व्यवहार या अवैध गतिविधि के लिए नहीं किया जा सकता।",
        ],
      },
      {
        heading: "2. सेवा लिस्टिंग",
        points: [
          "सेवा विवरण, मूल्य, उपलब्धता, संपर्क जानकारी और संबंधित व्यवसायिक जानकारी की सहीता के लिए सेवा प्रदाता स्वयं जिम्मेदार हैं।",
          "यदि कोई लिस्टिंग गलत, भ्रामक, हानिकारक या प्लेटफॉर्म नियमों के विरुद्ध पाई जाती है, तो Bhada24 उसे हटाने, सीमित करने या अपडेट करने का अधिकार रखता है।",
        ],
      },
      {
        heading: "3. व्यवसायिक संपर्क साझा करना",
        points: [
          "प्लेटफॉर्म का उपयोग करके सेवा प्रदाता सहमति देते हैं कि उनकी व्यवसायिक संपर्क जानकारी केवल व्यवसायिक उद्देश्य के लिए उपयोगकर्ताओं के साथ साझा की जा सकती है।",
          "इसमें सूचीबद्ध सेवाओं, पूछताछ, बुकिंग, मूल्यांकन या सेवा से जुड़ी चर्चा के लिए संपर्क शामिल है।",
        ],
      },
      {
        heading: "4. सेवा प्रदाता की जिम्मेदारी",
        points: [
          "सेवा प्रदाता अपने अकाउंट से दी गई सभी जानकारी और ग्राहकों से किए गए संवाद या प्रतिबद्धताओं के लिए स्वयं जिम्मेदार हैं।",
          "सेवा प्रदाताओं को पेशेवर व्यवहार बनाए रखना होगा और लागू कानूनों तथा व्यवसायिक दायित्वों का पालन करना होगा।",
        ],
      },
      {
        heading: "5. व्यवसाय की गारंटी नहीं",
        points: [
          "Bhada24 दृश्यता और कनेक्शन के लिए प्लेटफॉर्म देता है, लेकिन लीड, बुकिंग, ग्राहक रूपांतरण या व्यवसाय वृद्धि की गारंटी नहीं देता।",
          "सेवा प्रदाता और ग्राहक के बीच बनने वाला कोई भी व्यापारिक संबंध या लेनदेन उनकी अपनी जिम्मेदारी है।",
        ],
      },
      {
        heading: "6. अकाउंट निलंबन या हटाना",
        points: [
          "यदि कोई अकाउंट प्लेटफॉर्म नीतियों का उल्लंघन करता है, उपयोगकर्ता डेटा का दुरुपयोग करता है या प्लेटफॉर्म का हानिकारक/अनधिकृत उपयोग करता है, तो हम उसे सीमित, निलंबित या हटा सकते हैं।",
        ],
      },
    ],
  },
};

export default function TermsAndConditions() {
  const { i18n } = useTranslation();
  const content = i18n.language === "hi" ? termsContent.hi : termsContent.en;

  return (
    <div className={styles.pageContainer}>
      <AppHeader title={content.title} showBack />
      <div className={styles.contentWrapper}>
        <section className={styles.heroCard}>
          <h1 className={styles.pageTitle}>{content.title}</h1>
          <p className={styles.updatedAt}>{content.updated}</p>
          <p className={styles.introText}>{content.intro}</p>
        </section>

        <section className={styles.legalCard}>
          {content.sections.map((section) => (
            <div key={section.heading} className={styles.sectionBlock}>
              <h2 className={styles.sectionTitle}>{section.heading}</h2>
              {section.points.map((point) => (
                <p key={point} className={styles.sectionText}>{point}</p>
              ))}
            </div>
          ))}
        </section>
      </div>
    </div>
  );
}